const VENDOR_SCRIPTS = [
  '/assets/js/jquery.min.js',
  '/assets/js/jquery.migrate.js',
  '/assets/js/jquery.magnific-popup.min.js',
  '/assets/js/pathLoader.js',
];

const loadScript = (src) =>
  new Promise((resolve) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.async = false;
    script.onload = () => resolve();
    script.onerror = () => resolve();
    document.body.appendChild(script);
  });

export const loadVendorScripts = async () => {
  for (const src of VENDOR_SCRIPTS) {
    await loadScript(src);
  }
};
